import React, { useState } from 'react';
import { labelByKey } from '@cm/new-shared-fe/services/labels';
import { getParameter } from '@cm/new-shared-fe/services/parameters';
import { Fieldset, LoginFAS, SvgDefs, InfoField } from '@cm/react-components';

import styles from '@cm/design/styles.css'; // please don't use dimona.css
import datePickerStyles from '@cm/design/date-picker.css';

import { Form } from './form.component';
import { Confirmation } from './confirmation.component';
import { http } from './config/http.config';

const Application = (props) => {
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [interests, setInterests] = useState([]);
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);

  const insuranceIsActiveOnDomain = getParameter('insurance_activation') === 'true';

  const redirect = () => {
    // parameter for OIDC routes.
    const url = getParameter('user_info_start_link');
    const params = new URL(window.location.href).searchParams;
    // call the userinfo mock middleware when adding this param
    const mockUserinfo = params.has('mockUserinfo');
    // add an optional NRN to the userinfo mock middleware
    const mockNRN = params.has('NRN') ? params.get('NRN') : null;
    // add mockData to redirect url to prefill the form
    const mockData = params.has('mockData');
    window.location.href = `${url}?${mockUserinfo ? `mock=true&${mockNRN ? `RNR=${mockNRN}&` : ''}` : ''}redirect_to=${encodeURI(`${window.location.origin}${window.location.pathname}${mockData ? '?mockData=true' : ''}`)}`;
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    setError(false);
    try {
      const response = await fetch('/dimona-app/api/affiliations', {
        ...http.config,
        method: 'POST',
        body: JSON.stringify(data),
      });
      setLoading(false);
      if (!response.ok) {
        setError(await response.json());
        return;
      }
      setEmail(data.email);
      setInterests(Object.keys(data.insurance.insuranceInterest).filter(insurance => data.insurance.insuranceInterest[insurance]).map(insurance => labelByKey(`insurances.labels.${insurance.toUpperCase()}`)));
      setComplete(true);
    } catch (error) {
      setError(error);
    }
  };

  return (
    <>
      <style>
        {styles.toString()}
        {datePickerStyles.toString()}
        {/* TODO: Remove this css and use icon component instead */}
        {'\
          .icon {\
            font-family: "icons";\
            display: inline-block;\
            line-height: 1;\
            font-weight: normal;\
            font-style: normal;\
            speak: none;\
            text-decoration: inherit;\
            text-transform: none;\
            text-rendering: auto;\
            -webkit-font-smoothing: antialiased;\
            -moz-osx-font-smoothing: grayscale;\
          }\
        '}
      </style>

      <SvgDefs />

      <div className="container max-w-screen-lg mx-auto px-4 text-cmblack leading-normal mt-10">
        {!props.user?.NRN && (
          <LoginFAS
            title={labelByKey('login.fas.title')}
            text={labelByKey('login.fas.text')}
            buttonText={labelByKey('login.fas.buttonText')}
            onClick={redirect}
          />
        )}
        {props.user?.NRN && (
          <Fieldset legend={labelByKey('dimona.title')}>
            {!complete && (
              <Form
                user={props.user}
                onSubmit={handleSubmit}
                loading={loading}
                error={error}
                insuranceIsActiveOnDomain={insuranceIsActiveOnDomain}
              />
            )}
            {complete && <Confirmation interests={interests} email={email} insuranceIsActiveOnDomain={insuranceIsActiveOnDomain} />}
          </Fieldset>
        )}
        {props.error && <InfoField className="mt-4" error data-e2e="access-error">{labelByKey(props.error.message)}</InfoField>}
      </div>
    </>
  );
};

export default Application;
